module.exports = __webpack_public_path__ + "static/media/012.532c1152.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/012.jpg
// module id = 309
// module chunks = 0